import SvgIcn from '../../data/IconCompo';

function TagZ({ label, onClick, className = '', iconL, iconR, hoverL, hoverR }) {
  return (
    <div className={`tagz ${className}`} onClick={onClick}>
      {iconL && <SvgIcn icon={iconL} hover={hoverL} className="icon-left" />}
      <span>{label}</span>
      {iconR && <SvgIcn icon={iconR} hover={hoverR} className="icon-right" />}
    </div>
  );
}

export default TagZ;
